import ServiceCategoryPage from "../components/ServiceCategoryPage";
import borePumpTechnicianService from "../data/services/borePumpTechnicianService";

function BorePumpTechnician() {
  return <ServiceCategoryPage service={borePumpTechnicianService} />;
}

export default BorePumpTechnician;